var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 19.5,
    stroke: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_30801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6895 19.2572C17.6618 19.165 17.647 19.0679 17.647 18.9685V18.9669C17.647 18.6664 17.7804 18.3938 17.9941 18.2094L19.6067 16.676C19.6068 16.6759 19.6066 16.6761 19.6067 16.676C19.9131 16.384 20.1332 15.9989 20.2323 15.5682C20.3316 15.1372 20.3042 14.6851 20.1547 14.2717L19.4512 12.3219C19.4511 12.3218 19.4512 12.322 19.4512 12.3219C19.272 11.8259 18.9213 11.4297 18.4816 11.2049C18.0433 10.9807 17.5429 10.9394 17.079 11.0864C14.8145 11.8054 13.2211 13.9236 13.718 16.3291C14.1106 18.2304 14.8633 20.624 16.2925 23.1737C17.7258 25.7316 19.3609 27.6172 20.758 28.939C22.4676 30.553 24.9988 30.2434 26.7519 28.5467C27.1122 28.1981 27.3373 27.7128 27.3707 27.187C27.4041 26.6612 27.2422 26.1468 26.9266 25.749L25.6358 24.1222C25.3695 23.7858 25.0169 23.5452 24.6265 23.4248C24.2365 23.3045 23.8217 23.308 23.4335 23.4351L21.3013 24.1318C20.9315 24.2526 20.5252 24.148 20.2598 23.8637C19.6563 23.2174 19.1282 22.501 18.6857 21.7293L18.6759 21.712C18.2521 20.9375 17.921 20.1132 17.6895 19.2572ZM18.6476 18.9691C18.7339 19.2917 18.8356 19.6093 18.9524 19.9207C19.1216 20.3719 19.3223 20.8101 19.5532 21.2319C19.9577 21.9374 20.4402 22.5916 20.9907 23.1813L23.1224 22.4847C23.7071 22.2934 24.3336 22.288 24.9212 22.4692C25.5088 22.6504 26.0308 23.01 26.4199 23.5016L27.71 25.1274C28.1819 25.7223 28.4175 26.4815 28.3687 27.2504C28.3199 28.0192 27.9904 28.7399 27.4474 29.2653C25.4216 31.2259 22.2731 31.7455 20.0707 29.6654C18.6117 28.285 16.91 26.3213 15.4202 23.6626C13.9335 21.0103 13.1487 18.5174 12.7386 16.5313C12.1151 13.5124 14.1409 10.9701 16.7764 10.1333C17.4925 9.90619 18.2652 9.97102 18.9369 10.3146C19.6087 10.6581 20.1289 11.2545 20.3917 11.9823L21.0951 13.9316C21.3102 14.5265 21.3491 15.1746 21.2068 15.7926C21.0645 16.4106 20.7475 16.9704 20.2965 17.4L18.6476 18.9691Z",
    fill: "#FFB900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_30801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderCall);
export default __webpack_public_path__ + "static/media/header-call.1df143ac3bad7af5ba4952be6dda552e.svg";
export { ForwardRef as ReactComponent };